
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2AddFriendDialogProperties } from "../../../view/dialogs/Poker2AddFriendDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class BIGCommand extends Poker2Command {
    public static OFFER: number = 0;
    public static ACCEPT: number = 1;
    public static CANCEL: number = 2;
    public static REMOVE_BUDDY: number = 3;

    protected get cmdId(): string {
        return "big";
    }
    public executeCommand(error: number, params: any[]): boolean {
        try {
            var paramObj: any = JSON.parse(params[1]);
            var status: number = parseInt(paramObj.status);
            var offerPlayerId: number = parseInt(paramObj.offerPID);
            var receivePlayerId: number = parseInt(paramObj.receivePID);

            var offerPlayerName: string = paramObj.offerPName;
            var receivePlayerName: string = paramObj.receivePName;
            if (error == 0) {
                switch (status) {
                    case 0: //  angeboten
                        if (!Poker2Model.userData.gamePropertiesVO.ignoreBuddyRequest)
                            this.layoutManager.showDialog("Poker2AddFriendDialog", new Poker2AddFriendDialogProperties(offerPlayerName, offerPlayerId));
                        break;
                    case 1: // angenommen
                        Poker2Model.buddyList.addIngameBuddy(paramObj.buddy);
                        break;
                    case 2: // abgelehnt
                        if (offerPlayerId == Poker2Model.userData.playerID && Poker2Model.buddyList.isFriendshipRequested) {
                            Poker2Model.buddyList.isFriendshipRequested = false;
                            this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_friends_denied_title"),
                                Poker2Model.languageData.getTextById("generic_friends_denied_copy", [receivePlayerName])));
                        }
                        break;
                    case 3: // entfernt
                        if (receivePlayerId == Poker2Model.userData.playerID)
                            Poker2Model.buddyList.removeBuddy(offerPlayerId);
                        else
                            Poker2Model.buddyList.removeBuddy(receivePlayerId);
                        break;
                }
            }
        }
        catch (error) {
            console.error("Error: BIGCommand: " + error);
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
import { Poker2AddFriendDialog } from "../../../view/dialogs/Poker2AddFriendDialog";
import { Poker2StandardOkDialog } from "../../../view/dialogs/Poker2StandardOkDialog";
